/**
 * arrayChuck - split an array into Chuck
 * @param {Object} options
 * @param {[]} options.array - array
 * @param {number} options.chuckSize - chuckSize
 * @param {boolean} options.fillLastArray - fillLastArray
 */
export const arrayChuck = <T>({
  array,
  chuckSize,
  fillLastArray,
}: {
  array: T[];
  chuckSize: number;
  fillLastArray?: boolean;
}): T[][] => {
  const chunkedArray = [];
  let index = 0;
  while (index < array.length) {
    chunkedArray.push(array.slice(index, chuckSize + index));
    index += chuckSize;
  }
  if (
    fillLastArray &&
    chunkedArray[chunkedArray.length - 1]?.length < chuckSize
  ) {
    const lastArray = chunkedArray[chunkedArray.length - 1];
    const middleArray = chunkedArray[Math.floor((chunkedArray.length - 1) / 2)];
    let newLastArray = [...lastArray, ...middleArray];
    newLastArray = newLastArray.slice(0, chuckSize);
    //
    chunkedArray.pop();
    const newChunkedArray = [...chunkedArray, newLastArray];
    return newChunkedArray;
  } else {
    return chunkedArray;
  }
};
